import type { PluginUdiDto } from '@/generated'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useEdsStore = defineStore('eds', () => {
  const udiData = ref<PluginUdiDto | null>(null)

  function setUdiData(data: PluginUdiDto | null) {
    udiData.value = data
  }

  return {
    udiData,
    setUdiData
  }
})
